<template>
    <footer class="footer">
        <div class="footer__text">
            &copy; {{ new Date().getFullYear() }} {{ $t('footer.copyrights')}}
        </div>
    </footer>
</template>

<script>
    import Vue from 'vue';
    import { Component } from 'vue-property-decorator';

    @Component
    export default class TheFooter extends Vue {
        name = 'the-footer';
    }
</script>



// WEBPACK FOOTER //
// src/components/general/TheFooter.vue